<template>
    <div class="d-flex justify-content-center login-page">
        <app-login-form />
    </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import LoginForm from './LoginForm.vue';
    

    export default {
        name: 'login-page',
        components: {
            appLoginForm: LoginForm
        }
    }
</script>